















































































// import request from "@/utils/request";
// import CheckDictionary from '@/components/dictionary/checkbox-dictionary.vue'
import { Component, Vue, Prop } from 'vue-property-decorator'
@Component({
  name: 'addActive'
  // components: { CheckDictionary }
})
export default class addActive extends Vue {
  groupList: any = [{ key: '1', value: '成员' }, { key: '2', value: '市长客人' }, { key: '3', value: '观察员' }]
  @Prop({
    type: Object, // 父组件传递给子组件的数据类型
    required: true, // 是否必填
    default: {} // 默认值， 如果传入的是 Object，则要 default: ()=>({}) 参数为函数
  })
  activeFormData: any
  @Prop({
    type: Boolean, // 父组件传递给子组件的数据类型
    required: true, // 是否必填
    default: true // 默认值， 如果传入的是 Object，则要 default: ()=>({}) 参数为函数
  })
  isEdit: any
  handleChange1(value: any) {
    console.log(value)
  }
  handleChange2(value: any) {
    console.log(value)
  }
}
